import { readLocalStorage, useLocalStorage } from './useLocalStorage';

export const useForcedTheme = () => useLocalStorage('forced-dark-theme');

export const readForcedTheme = () => readLocalStorage('forced-dark-theme');
